import { HTTP_CODE } from '@/utils/request'
import * as service from './service'
import Toast from 'antd-mobile/es/toast'
export default {
  namespace: 'goldDetail',
  state: {
    demoData: {}
  },
  effects: {
    * getHemo ({ payload }, { call, put }) {
      const res = yield call(service.getHemo, payload)
      if (res.status !== HTTP_CODE.success) {
        console.error(res.data.err)
      }
      return res.data
    },
    * getCityRuleDesc ({ payload }, { call, put }) {
      const res = yield call(service.getCityRuleDesc, payload)
      if (res.status !== HTTP_CODE.success) {
        console.error(res.data.err)
      }
      return res.data
    },
    * getFlowLog ({ payload }, { call, put }) {
      try {
        const res = yield call(service.getFlowLog, payload)
        if (res.status !== HTTP_CODE.success) {
          console.error(res.data.err)
        }
        return res.data
      } catch (error) {
        console.log(error, 'errorerror')
      }
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
